import { useState } from 'react';
import { useIntl } from 'react-intl';
import { Col, Row } from 'reactstrap';
import Toast from '../../helpers/Toast';
import { Utilities } from '../../helpers/Utilities';
import { CreateScheduleDTO } from '../../models/Scheduler/CreateScheduleDTO';
import { SchedulerService } from '../../services/SchedulerService';
import ButtonComponent from '../ButtonComponent';
import InputComponent from '../InputComponent';
import SelectComponent from '../SelectComponent';

type CreateSchedulerSecondTabProps = {
    scheduleDTO: CreateScheduleDTO;
    setScheduleDTO: React.Dispatch<React.SetStateAction<CreateScheduleDTO>>;

    onFetchData: () => void;
};

function CreateSchedulerSecondTab(props: CreateSchedulerSecondTabProps) {

    const [isCreatingSchedulingLoading, setIsCreatingSchedulingLoading] = useState<boolean>(false);
    const schedulerService = new SchedulerService();
    const intl = useIntl();

    const [checkinStartDate, setCheckinStartDate] = useState<string>(
        props.scheduleDTO.checkinStartDate ? Utilities.formatDateYYYYMMDD(new Date(props.scheduleDTO.checkinStartDate)) : Utilities.formatDateYYYYMMDD(new Date())
    );
    const [checkinStartTime, setCheckinStartTime] = useState<string>(
        props.scheduleDTO.checkinStartDate ? Utilities.GetTimeFromDateTime(new Date(props.scheduleDTO.checkinStartDate)) : Utilities.GetTimeFromDateTime(new Date())
    );
    const [checkinEndDate, setCheckinEndDate] = useState<string>(
        props.scheduleDTO.checkinEndDate ? Utilities.formatDateYYYYMMDD(new Date(props.scheduleDTO.checkinEndDate)) : Utilities.formatDateYYYYMMDD(new Date())
    );
    const [checkinEndTime, setCheckinEndTime] = useState<string>(
        props.scheduleDTO.checkinEndDate ? Utilities.GetTimeFromDateTime(new Date(props.scheduleDTO.checkinEndDate)) : Utilities.GetTimeFromDateTime(new Date())
    );
    const [checkinNotes, setCheckinNotes] = useState<string>(props.scheduleDTO.checkinNotes || '');
    const [checkinTechnician, setCheckinTechnician] = useState<string>(props.scheduleDTO.checkinTechnicianId || '');

    const CreateScheduler = async () => {
        setIsCreatingSchedulingLoading(true);

        const newSchedule: CreateScheduleDTO = {
            assistanceId: props.scheduleDTO.assistanceId || null,
            clientErpId: props.scheduleDTO.clientErpId || null,
            equipmentErpId: props.scheduleDTO.equipmentErpId || null,
            checkinStartDate: checkinStartDate && checkinStartTime ?
                Utilities.CombineDateAndTime(new Date(checkinStartDate), checkinStartTime) : null,
            checkinEndDate: checkinEndDate && checkinEndTime ?
                Utilities.CombineDateAndTime(new Date(checkinEndDate), checkinEndTime) : null,
            checkinNotes: checkinNotes || null,
            checkinTechnicianId: checkinTechnician || null,
            observations: props.scheduleDTO.observations || null,

            type: "CheckIn"
        };
        
        const response = await schedulerService.Create(newSchedule);
        if (response.success == false) {
            setIsCreatingSchedulingLoading(false);
            Toast.Show("error", response.message);
            return;
        }

        setIsCreatingSchedulingLoading(false);
        Toast.Show("success", response.message);

        props.setScheduleDTO({
            ...props.scheduleDTO,
            assistanceId: response.obj?.id || null,
            assistanceName: `${response.obj?.erpDocType} ${response.obj?.erpSerie} ${response.obj?.erpNumDoc}` || null
        });

        props.onFetchData();
        
        setCheckinStartDate(Utilities.formatDateYYYYMMDD(new Date()));
        setCheckinStartTime(Utilities.GetTimeFromDateTime(new Date()));
        setCheckinEndDate(Utilities.formatDateYYYYMMDD(new Date()));
        setCheckinEndTime(Utilities.GetTimeFromDateTime(new Date()));
        setCheckinNotes('');
        setCheckinTechnician('');
    };
    return (
        <div>
            <Row
                style={{
                    margin: "5% 0% 0% 0%",
                    padding: "0px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                }}
            >
                <InputComponent
                    xl={3}
                    lg={3}
                    md={3}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"date"}
                    value={checkinStartDate}
                    label={"Dia Inicial Check-In"}
                    readOnly={false}
                    onChange={(t: string) => {
                        setCheckinStartDate(t);

                        const start = new Date(t + 'T' + checkinStartTime);
                        const end = new Date(checkinEndDate + 'T' + checkinEndTime);

                        let updatedEndDate = end;

                        // Atualiza o dia final apenas se for anterior ao novo início
                        if (end < start) {
                            updatedEndDate = new Date(start);
                            setCheckinEndDate(t);
                        }

                        props.setScheduleDTO({
                            ...props.scheduleDTO,
                            checkinStartDate: start,
                            checkinEndDate: updatedEndDate,
                        });
                    }}
                />
                <InputComponent
                    xl={3}
                    lg={3}
                    md={3}
                    sm={3}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"time"}
                    value={checkinStartTime}
                    label={"Hora Inicial Check-In"}
                    readOnly={false}
                    onChange={(t: string) => {
                        setCheckinStartTime(t);

                        const start = new Date(checkinStartDate + 'T' + t);
                        const end = new Date(checkinEndDate + 'T' + checkinEndTime);

                        let updatedEnd = end;

                        // Atualiza a hora de fim apenas se for anterior ou igual à hora de início
                        if (end <= start) {
                            updatedEnd = new Date(start);
                            updatedEnd.setMinutes(start.getMinutes() + 15);

                            const formattedEndTime = updatedEnd.toTimeString().substring(0, 5);
                            setCheckinEndTime(formattedEndTime);
                        }

                        props.setScheduleDTO({
                            ...props.scheduleDTO,
                            checkinStartDate: start,
                            checkinEndDate: updatedEnd,
                        });
                    }}
                />
            </Row>
            <Row
                style={{
                    margin: "0px",
                    padding: "0px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                }}
            >
                <InputComponent
                    xl={3}
                    lg={3}
                    md={3}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"date"}
                    value={checkinEndDate}
                    label={"Dia Final Check-In"}
                    readOnly={false}
                    onChange={(t: string) => {
                        setCheckinEndDate(t);
                        props.setScheduleDTO({
                            ...props.scheduleDTO,
                            checkinEndDate: new Date(t + 'T' + checkinEndTime)
                        });
                    }}
                />
                <InputComponent
                    xl={3}
                    lg={3}
                    md={3}
                    sm={3}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"time"}
                    value={checkinEndTime}
                    label={"Hora Final Check-In"}
                    readOnly={false}
                    onChange={(t: string) => {
                        setCheckinEndTime(t);
                        props.setScheduleDTO({
                            ...props.scheduleDTO,
                            checkinEndDate: new Date(checkinEndDate + 'T' + t)
                        });
                    }}
                />
            </Row>

            <Row
                style={{
                    margin: "0px",
                    padding: "0px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                }}
            >
                <InputComponent
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"textArea"}
                    value={checkinNotes}
                    label={"Observações Check-In"}
                    readOnly={false}
                    onChange={(t: string) => {
                        setCheckinNotes(t);
                        props.setScheduleDTO({
                            ...props.scheduleDTO,
                            checkinNotes: t
                        });
                    }}
                />
            </Row>

            <Row
                style={{
                    margin: "0px",
                    padding: "0px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                }}
            >
                <SelectComponent
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    style={{ width: "100%", height: "43px" }}
                    label={"Técnico Check-In"}
                    selectedItemValue={checkinTechnician}
                    items={Utilities.GetTechnicians}
                    onChange={(t: string) => {
                        setCheckinTechnician(t);
                        props.setScheduleDTO({
                            ...props.scheduleDTO,
                            checkinTechnicianId: t
                        });
                    }}
                />
            </Row>

            <Row
                style={{
                    margin: "2% 0% 0% 0%",
                    padding: "0px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                }}
            >

                <Col xl={3} lg={3} md={3} sm={12} xs={12}>
                    <ButtonComponent
                        disabled={isCreatingSchedulingLoading}
                        loading={isCreatingSchedulingLoading}
                        text={intl.formatMessage({ id: "Screens.CreateScheduler.Navbar" })}
                        onClick={CreateScheduler}
                        style={{ width: "100%" }}
                    />
                </Col>
            </Row>
        </div>
    )
}

export default CreateSchedulerSecondTab;